import React from 'react';
import {Box, Typography} from '@mui/material';

const NoRowsOverlayLabel = ({message}) => (
  <Box
    sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '5rem',
    }}>
      <Typography>{message}</Typography>
  </Box>
);

export default NoRowsOverlayLabel;